/**
 * @generated SignedSource<<bc3944fc9768fa0c07c567665fc5f98f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteVideoInput = {
  clientMutationId?: string | null | undefined;
  videoId?: string | null | undefined;
  videoRawId?: number | null | undefined;
};
export type VideoAnswersField_DeleteVideoMutation$variables = {
  input: DeleteVideoInput;
};
export type VideoAnswersField_DeleteVideoMutation$data = {
  readonly deleteVideo: {
    readonly video: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type VideoAnswersField_DeleteVideoMutation = {
  response: VideoAnswersField_DeleteVideoMutation$data;
  variables: VideoAnswersField_DeleteVideoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoAnswersField_DeleteVideoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVideoPayload",
        "kind": "LinkedField",
        "name": "deleteVideo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VideoAnswersField_DeleteVideoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteVideoPayload",
        "kind": "LinkedField",
        "name": "deleteVideo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Video",
            "kind": "LinkedField",
            "name": "video",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5c69c61961b02191cb7b9771b98f9add",
    "id": null,
    "metadata": {},
    "name": "VideoAnswersField_DeleteVideoMutation",
    "operationKind": "mutation",
    "text": "mutation VideoAnswersField_DeleteVideoMutation(\n  $input: DeleteVideoInput!\n) {\n  deleteVideo(input: $input) {\n    video {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ce7cf37b1965ef417374c55423015142";

export default node;
